module.exports = require("./kok");